export enum LoadingState {
    Loading = 0,
    LoadedOK = 1,
    LoadedNoData = 2,
    ErrorLoading = 3
}
